import { connect } from 'react-redux';
import UserGroupListView from './UserGroupListView.jsx';
import { fetchUserGroupsForUser } from 'src/legacy/redux/actions/userManagement.jsx';
import { fetchUserGroup } from 'src/legacy/redux/actions/userGroups';         
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import _ from "lodash";

const mapStateToProps = (state, ownProps) => {
  return {
    loading: _.get(state.legacyRootReducer, "settings.userManagement.userGroups.loading"),
    currentPage: _.get(state.legacyRootReducer, "settings.userManagement.userGroups.pagination.current"),
    totalPages: _.get(state.legacyRootReducer, "settings.userManagement.userGroups.pagination.totalPages"),
    userGroups: _.get(state.legacyRootReducer, "settings.userManagement.userGroups.items")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserGroupsForUser: (page, user) => {
        dispatch(fetchUserGroupsForUser(page, user))
    },
    fetchUserGroup: (id) => {
        return dispatch(fetchUserGroup(id));
    }
  }
}

const UserGroupListContainer = connect (
  mapStateToProps,
  mapDispatchToProps
)(UserGroupListView);

export default withUseHooks(UserGroupListContainer);